export enum StepCode {
    TERMS, INFO, DONE
}